module.exports = __webpack_public_path__ + "media/4x3/tw-8a194685.svg";